export const onlyRole = (roles, role) => roles.length < 2 && roles.includes(role);
